import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import DemandeDevisService, { FilterDemandeDevis } from '../services/DemandeDevisService';
import { DemandeDevisActions, DemandeDevisActionTypes } from './action-types';
import { DEMANDE_DEVIS } from './mutation-types';
import { DemandeDevisState } from './state';

export const actions: ActionTree<DemandeDevisState, RootState> = {
    async [DemandeDevisActions.GET_DEMANDES_DEVIS]({ commit }: DemandeDevisActionTypes, payload: FilterDemandeDevis) {
        commit(DEMANDE_DEVIS.SET_ERROR, undefined);
        commit(DEMANDE_DEVIS.SET_IS_LOADING, true);
        commit(DEMANDE_DEVIS.SET_PAGE, payload.page);
        try {
            const response = await DemandeDevisService.getDemandesDevis(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(DEMANDE_DEVIS.SET_ITEMS, response.data);
                    commit(DEMANDE_DEVIS.SET_NB_OF_PAGES, response.headers.pages);
                    commit(DEMANDE_DEVIS.SET_COUNT, response.headers.count);
                } else {
                    commit(DEMANDE_DEVIS.ADD_ITEMS, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(DEMANDE_DEVIS.SET_IS_LOADING, false);
        } catch (error) {
            commit(DEMANDE_DEVIS.SET_IS_LOADING, false);
            commit(DEMANDE_DEVIS.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },

    async [DemandeDevisActions.GET_ATTACHMENT]({ commit }: DemandeDevisActionTypes, payload: any){
        try {
            commit(DEMANDE_DEVIS.SET_ATTACHMENT_LOADING, true);
            const response = await DemandeDevisService.getPieceJointeById(payload);
            if (response.status === 200 && response.data !== undefined) {
                commit(DEMANDE_DEVIS.SET_ATTACHMENT_LOADING, false);
                const contentType = response.headers['content-type'];
                if(contentType.includes('image')){
                    commit(DEMANDE_DEVIS.SET_ATTACHMENT, response.data);
                    commit(DEMANDE_DEVIS.SET_ATTACHMENT_TYPE, contentType);
                } else if(contentType === 'application/pdf'){
                    window.open(URL.createObjectURL(new Blob([response.data], { type: contentType })));
                }
            } else {
                commit(DEMANDE_DEVIS.SET_ATTACHMENT_LOADING, false);
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
        } catch (error) {
            commit(DEMANDE_DEVIS.SET_ATTACHMENT_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },

    async [DemandeDevisActions.GET_XLS_DEMANDE_DEVIS]({ commit }: DemandeDevisActionTypes, payload: FilterDemandeDevis) {
        commit(DEMANDE_DEVIS.SET_EXPORT_XLS_IS_LOADING, true);
        try {
            const response = await DemandeDevisService.getExportXlsDemandeDevis(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data],{ type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_demande_devis.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                    commit(
                        `errorToaster/${ERROR.SET_MESSAGE}`,
                        await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                        { root: true }
                );
            }
            commit(DEMANDE_DEVIS.SET_EXPORT_XLS_IS_LOADING, false);
        } catch (error) {
            commit(DEMANDE_DEVIS.SET_EXPORT_XLS_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },

    async [DemandeDevisActions.GET_PJ_TO_EDIT]({ commit }: DemandeDevisActionTypes, payload: any) {
        try {
            commit(DEMANDE_DEVIS.SET_ATTACHMENT_LOADING, true);
            const response = await DemandeDevisService.getPieceJointeById(payload.id);
            if (response.status === 200 && response.data) {
                commit(DEMANDE_DEVIS.SET_ATTACHMENT_LOADING, false);
                const contentType = response.headers['content-type'];
                const name = payload.libelle ?? 'piece_jointe';
                const lastModified = payload.lastModified ?? Date.now();
                return new File([response.data], name, { type: contentType, lastModified });
            } else {
                return null;
            }
        } catch (error) {
            commit(DEMANDE_DEVIS.SET_ATTACHMENT_LOADING, false);

            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });

            return null;
        }
    }

};
